// extracted by mini-css-extract-plugin
export var burger = "header-module--burger--b0974";
export var headband = "header-module--headband--975b5";
export var headbandBg = "header-module--headbandBg--e6ac4";
export var logo = "header-module--logo--dfe6e";
export var logoBlack = "header-module--logoBlack--98b5c";
export var logoWhite = "header-module--logoWhite--17788";
export var wrapper = "header-module--wrapper--ad73e";